export default __webpack_public_path__ + "static/media/Aptean.a5424df0.png";